import { render, staticRenderFns } from "./SpeciesFactBox.vue?vue&type=template&id=65ecd81f&scoped=true&"
import script from "./SpeciesFactBox.vue?vue&type=script&lang=js&"
export * from "./SpeciesFactBox.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesFactBox.vue?vue&type=style&index=0&id=65ecd81f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecd81f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
